import React from 'react'
import { FormFieldInterface } from 'src/shared/types/entities/form-interface'
import { BasePublisherBaseField } from '../../base-publisher-field/base-publisher-base-field'
import { useFormField } from '../hooks/use-form-field'

interface FormBaseFieldSubEntityProps {
  fieldSubEntity: FormFieldInterface
}

export const FormBaseFieldSubEntity = ({
  fieldSubEntity,
}: FormBaseFieldSubEntityProps) => {
  const { value, onChange, errors } = useFormField({
    fieldSubEntity,
  })
  return (
    <BasePublisherBaseField
      entity={fieldSubEntity}
      value={value}
      onChange={onChange}
      errors={errors}
    />
  )
}
